import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	grid-template-columns: auto 1fr;
	position: relative;
	margin-top: 32px;
`;

export const LayoutPage = styled.div`
	display: grid;
	width: 100%;
	background-color: white;
	padding: 20px;

	.data-list-wrapper {
		z-index: 0;
	}
`;
